import { assertNotEmpty } from '@festina-life/core'
import { useReducer } from 'react'

import type { WizardAction, WizardState, WizardStep } from './types'

export const useWizard = <T extends string, Data>(
  steps: WizardStep<T, Data>[],
) => {
  const initialState = { stepId: steps[0].id, history: [] }

  const resolveStep = (stepId: T) => {
    const step = steps.find((step) => step.id === stepId)
    assertNotEmpty(step)

    return step
  }

  const reducer = (
    state: WizardState<T>,
    action: WizardAction<Data>,
  ): WizardState<T> => {
    const currentStep = resolveStep(state.stepId)

    switch (action.type) {
      case 'next': {
        const nextStepId = currentStep.next?.(action.data) ?? currentStep.id
        const nextStep = resolveStep(nextStepId)
        return {
          stepId: nextStep.id,
          history:
            nextStepId !== currentStep.id
              ? [...state.history, currentStep.id]
              : [...state.history],
        }
      }
      case 'back': {
        const nextHistory = [...state.history]
        const previousStepId = nextHistory.pop()
        return {
          stepId: previousStepId ?? currentStep.id,
          history: nextHistory,
        }
      }
    }
  }

  return useReducer(reducer, initialState)
}
